/**
 * A person's colour — `docs/activity.md` §3 (People colours), §4.5.
 *
 * `users.colour` is one of these eight edges, given in the order a company's
 * people were made (0134's `person_colour()`), and stable: who else is on the
 * calendar never re-shuffles it. Each edge has the darker text its initials
 * are written in and the light tint behind them — the boards' own pairs.
 */
export const PERSON_COLOURS = [
    { edge: '#3f4f9a', text: '#3f4f9a', tint: '#e9ecf7' },
    { edge: '#7a4fb0', text: '#6b43a3', tint: '#eee7f8' },
    { edge: '#1f8a8a', text: '#155e5e', tint: '#e1f2f2' },
    { edge: '#b0731a', text: '#7a4f10', tint: '#fbf0dc' },
    { edge: '#b4473a', text: '#9a2a1e', tint: '#fde8e6' },
    { edge: '#2e7d4f', text: '#1f5c39', tint: '#cfe5d7' },
    { edge: '#2b66a8', text: '#2b66a8', tint: '#e3edf9' },
    { edge: '#b45309', text: '#b45309', tint: '#fff4e5' },
];
/** Two more the boards draw people in (an office tone and a quiet one), for colours set by hand. */
const OTHER_TONES = [
    { edge: '#5b6fb5', text: '#5b6fb5', tint: '#e9ecf7' },
    { edge: '#6f6e68', text: '#6f6e68', tint: '#efeee9' },
];
const NEUTRAL = { edge: '#6f6e68', text: '#6f6e68', tint: '#efeee9' };
/** The three colours of a person, from `users.colour`. */
export function toneOf(colour) {
    const wanted = colour?.toLowerCase();
    if (!wanted)
        return NEUTRAL;
    return PERSON_COLOURS.find((tone) => tone.edge === wanted)
        ?? OTHER_TONES.find((tone) => tone.edge === wanted)
        ?? { edge: wanted, text: wanted, tint: NEUTRAL.tint };
}
/** *Tom* from *Tom Reyes*. */
export const firstNameOf = (name) => name.trim().split(/\s+/)[0] ?? name;
/**
 * The people button's label (§3): the person's name for one, the group's name
 * for a group, *Tom and Hannah* for two, *<n> people* otherwise; *Unassigned ·
 * <branch>* alone, and *<label> + Unassigned* with others.
 */
export function peopleLabel(input) {
    const { names, groupName, unassigned } = input;
    let label = '';
    if (groupName)
        label = groupName;
    else if (names.length === 1)
        label = names[0];
    else if (names.length === 2)
        label = `${firstNameOf(names[0])} and ${firstNameOf(names[1])}`;
    else if (names.length > 2)
        label = `${names.length} people`;
    if (unassigned.length === 0)
        return label || 'Nobody';
    if (!label)
        return unassigned.length === 1 ? `Unassigned · ${unassigned[0]}` : `Unassigned · ${unassigned.length} branches`;
    return `${label} + Unassigned`;
}
/** *Tom, Hannah, Luis and Maya* — a group's suggested name, and a list in a sentence. */
export function namesInWords(names) {
    if (names.length <= 1)
        return names[0] ?? '';
    return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
//# sourceMappingURL=people.js.map